// ABOUTME: TEMPORARY local adapter — accessible checkbox built on a native input because @hm/fundamental
// ABOUTME: exposes only a Switch, not a Checkbox. Tech debt: add a Checkbox to @hm/fundamental and replace this.

import React from 'react'

import {OverrideDot} from './OverrideDot'

export interface UnloadingMethodCheckboxProps {
  code: string
  label: string
  checked: boolean
  isOverridden?: boolean
  disabled?: boolean
  onChange: (checked: boolean) => void
  'data-cy'?: string
}

export const UnloadingMethodCheckbox: React.FC<UnloadingMethodCheckboxProps> = ({
  code,
  label,
  checked,
  isOverridden = false,
  disabled = false,
  onChange,
  'data-cy': dataCy,
}) => {
  const inputId = `unloading-method-checkbox-${code}`

  return (
    <label
      htmlFor={inputId}
      className={`flex items-center gap-2 ${disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'}`}
    >
      <input
        id={inputId}
        type="checkbox"
        checked={checked}
        disabled={disabled}
        aria-label={label}
        onChange={(e) => onChange(e.target.checked)}
        data-cy={dataCy}
        className="size-4 shrink-0 rounded-sm border border-foreground_faded accent-primary cursor-pointer disabled:cursor-not-allowed"
      />
      <span className="text-sm leading-5 text-foreground">{label}</span>
      {isOverridden && <OverrideDot />}
    </label>
  )
}
